export const formError = {
  "form_error_required": "This field is required",
  "form_default_error": "Invalid input",
  "form_error_email": "This email is not valid",
  "form_error_email_password": "Password should contains uppercase, lowercase and symbols",
  "form_error_min": "Should be minmum {{min}} charcters long",
  "form_error_email_confirm_password": "Password not identical",
  "form_error_phone": "The phone number is not valid",
  "form_error_email_or_phone_required": "Email or phone number is required"
}